import { CSS, Heading } from '@ghq-abi/design-system';

type FirstAndLastNameProps = {
  firstName?: string;
  lastName: string;
  highlightFirstName?: boolean;
  name?: string;
  css?: CSS;
};

export function FirstAndLastName({
  lastName,
  firstName,
  highlightFirstName,
  name,
  css,
}: FirstAndLastNameProps) {
  const fullName = name || `${firstName} ${lastName}`.trim();
  const [fName, lName] = fullName.split(' ');

  if (!fName && !lName) {
    return null;
  }

  return (
    <Heading
      size="sm"
      css={{
        lineHeight: '$normal',
        color: '$gray750',
        fontSize: '$sm',
        limitLines: 1,
        span: { fontWeight: '$medium' },
        ...css,
      }}
    >
      <span>
        {highlightFirstName ? <b>{fName}</b> : fName} {lName}
      </span>
    </Heading>
  );
}
